<template lang="pug">
  div
    v-card.mb-2(style="border-radius: 0px")
      v-row.pt-3.px-3(no-gutters)
        v-col.shrink.pb-0(v-if="initImport && !product.product")
          y-checkbox.mt-0.pt-0(v-model="product.check" hide-details)
        v-col.pb-0
          div.product-list-title.pr-2 {{ product.name }}
        //- v-col.shrink.pb-0(v-if="!product.product")
          v-btn.mt-n1(icon)
            v-icon(size="30") mdi-link
      v-row.mx-2.pb-2(no-gutters align="center")
        v-col.shrink
          v-img.my-2.mr-2(v-if="product.image_url" :src="product.image_url" max-width="80px" width="80px" height="80px")
          v-img.my-2.mr-2(v-else :src="require('@/assets/image_placeholder.png')" max-width="80px" width="80px" height="80px")
        v-col
          v-row
            v-col
              p.p1.basic800--text ID &#35;{{ product.rid }}
          v-row(align="center" no-gutters)
            v-col.py-0
              div.p1.basic800--text {{ product.product ?  product.product.price : '' | displayPrice }}
          v-row(v-if="product.updated_at" align="end")
            v-col.pb-0
              span.c1.basic600--text {{ $t('last_updated_on') }} {{ product.updated_at | convertServerDate }}
        v-col.py-0.shrink(v-if="product.product")
          v-chip(color="success" small label) {{ $t('synced') }}
</template>

<script>
import { mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText.vue'
export default {
  name: 'ShopifyProductItem',
  components: { ShowMoreText },
  props: ['initImport', 'product'],
  data: () => ({
  }),
  watch: {
    product: {
      deep: true,
      handler (val) {
        this.$emit('update:product', val)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ])
  }
}
</script>

<style scoped>
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
</style>